import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDisconnect } from "wagmi";

const Logout = () => {
  const navigate = useNavigate();
  const { disconnect } = useDisconnect();

  useEffect(() => {
    localStorage.clear();
    disconnect();

    navigate("/", { replace: true });
  }, [disconnect, navigate]);

  return null; 
};

export default Logout;
